import React, { useState } from "react";
import moment from "moment";
import { VideoListTable } from "../../../calendar/VideoListTable";
import { displayDateRange } from "../../../../../utils/questionnaire";
import SvgIcon from "../../../../../parts/SvgIcon";

const SummaryVideoList = ({
  start,
  end,
  date,
  athlete,
  locals,
  query,
  organizationCoachParam,
}) => {
  const [previousExercises, setPreviousExercises] = useState([]);
  const [counter, setCounter] = useState(1);
  const [videosToShow, setVideosToShow] = useState([]);
  const [videosToCompareState, setVideosToCompareState] = useState([]);
  const [videosToFilter, setVideosToFilter] = useState([]);
  const [videosSorted, setVideosSorted] = useState(false);

  const sortVideosByDate = () => {
    if (videosSorted) {
      const sortedDescending = videosToShow
        .slice()
        .sort((a, b) => new Date(a.date) - new Date(b.date));
      setVideosToShow(sortedDescending);
    } else {
      const sortedAscending = videosToShow
        .slice()
        .sort((a, b) => new Date(b.date) - new Date(a.date));

      setVideosToShow(sortedAscending);
    }

    setVideosSorted(!videosSorted);
  };

  return (
    <article id="summary-video-list">
      <header>
        <div>
          <h4>Video List</h4>
          <p className="p4">{displayDateRange(start, end)}</p>
        </div>

        <a
          href={`
            /athlete-portal/metrics/video-list?date=${date}&athlete=${athlete._id}${organizationCoachParam}&summary=true
            `}
          className="composition-see-more"
        >
          <span>See more</span>
          <SvgIcon
            noFilterOnLight={true}
            src="/img/new-icons/arrow-square-right-gradient.svg"
          />
        </a>
      </header>
      <section role="table-wrapper">
        <table role="report-table">
          {videosToShow && videosToShow.length > 0 && (
            <thead>
              <tr>
                <th
                  className="date"
                  onClick={() => {
                    sortVideosByDate();
                  }}
                >
                  Date
                  <img alt="sort" src="/img/svg/up_down_arrows.svg" />
                </th>
                <th>Exercise Name</th>
                <th>Protocol</th>
                <th>Comments</th>
                <th>Status</th>
                <th>Watched</th>
                <th>Video</th>
              </tr>
            </thead>
          )}
          <VideoListTable
            locals={locals}
            query={query}
            compareState={false}
            setVideosToCompareState={setVideosToCompareState}
            initialDateState={moment(start).subtract(2, "years").toDate()}
            endDateState={moment(end).toDate()}
            sortState={-1}
            previousExercises={previousExercises}
            setPreviousExercises={setPreviousExercises}
            counter={counter}
            setCounter={setCounter}
            videosToShow={videosToShow}
            videosToFilter={videosToFilter}
            setVideosToFilter={setVideosToFilter}
            setVideosToShow={setVideosToShow}
            isCheckIn={true}
          />
        </table>
      </section>

      {videosToShow && videosToShow.length <= 0 && (
        <div className="no-data">There are no videos to show</div>
      )}
    </article>
  );
};

export default SummaryVideoList;
